<template>
<div class="projects">
  <InfoPanel
    v-for="(p, i) in projects"
    :key="p.uid"
    :reverse="i % 2 == 0"
    :img="p.image"
    :link="p.route"
    class="project-panel">
    <h2>{{ p.label }}</h2>
    <p class="describe">
      {{ p.description }}
    </p>
  </InfoPanel>
</div>
</template>

<script>
import InfoPanel from '@/components/sections/InfoPanel';
import { mapState } from 'vuex'
import ScrollIntoView from '@/mixins/ScrollIntoView';

export default {
  name: 'Projects',
  mixins: [
    ScrollIntoView,
  ],
  props: {},
  data() {
    return {};
  },
  components: {
    InfoPanel
  },
  created() {},
  watch: {},
  computed: {
    ...mapState([
      'projects',
    ])
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.projects  {

}
</style>
